<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#detail6_1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES33UC14']['0'] }}
          </h3>
        </div>
        <div id="detail6_1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail-block">
              <div class="row">
              
                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC11']['160'] }}</label>
                    <input type="text" id="coddesc_codinput" name="coddesc_codinput" class="form-control" readonly="readonly" v-model="descCodinput" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC11']['10'] }}</label>
                    <input type="text" id="coddesc_codempid" name="coddesc_codempid" class="form-control" readonly="readonly" v-model="descCodempid" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC11']['20'] }}</label>
                    <input type="text" id="dtereq" name="dtereq" class="form-control" readonly="readonly" :value="setDateOutput(detail.detail.dtereq)" />
                  </div>
                </div>
              </div>
            </div>

            <!-- New -->
            <div class="detail-header">{{ labels['HRES33UC11']['40'] }}</div>
            <hrms-table :columns="tab6Table1" :data="detail.table1" />

            <!-- Old -->
            <div class="detail-header">{{ labels['HRES33UC11']['50'] }}</div>
            <hrms-table :columns="tab6Table2" :data="detail.table2" />
            
          </div>
        </div>
      </div>

    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ buttonLabels['back'] }}</button>
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres33u-detail6',
  props: [ 'labels', 'detail', 'toggle', 'data', 'nowLang', 'tab6Table1', 'tab6Table2', 'buttonLabels' ],
  computed: {
    descCodinput () {
      return this.detail.detail.codinput + ' - ' + this.detail.detail.desc_codinput
    },
    descCodempid () {
      return this.detail.detail.codempid + ' - ' + this.detail.detail.desc_codempid
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail6.vue?723dfdc5